(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // The stepper's own script (snippets/quantity-selector.liquid) is only loaded
  // on pages that render it, so an empty cart on the home page left the drawer's
  // + / - buttons dead after an add. Define it here too; sections always load.
  if (!customElements.get('quantity-selector')) {
    customElements.define('quantity-selector', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('.quantity-selector__input');
        this.addEventListener('mousedown', (event) => {
          if (event.target.closest('.quantity-selector__button')) event.preventDefault();
        });
        this.addEventListener('click', (event) => {
          const button = event.target.closest('.quantity-selector__button');
          if (!button || !this.input) return;
          const min = this.input.min === '' ? 1 : Number(this.input.min);
          const next = Math.max(min, Number(this.input.value) + Number(button.dataset.step));
          if (next === Number(this.input.value)) return;
          this.input.value = next;
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }
    });
  }

  class CartDrawer extends HTMLElement {
    connectedCallback() {
      this.addEventListener('change', this.onQuantityChange.bind(this));
      this.addEventListener('click', this.onRemoveClick.bind(this));
      document.addEventListener('cart:updated', this.onCartUpdated.bind(this));
    }

    onCartUpdated(event) {
      const sections = event.detail?.sections;
      if (!sections || !sections['cart-drawer']) return;

      const doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      // replace the whole drawer content: header count, items and the footer
      // (checkout / view cart), which only exists once the cart has items
      const fresh = doc.querySelector('cart-drawer');
      if (fresh) this.innerHTML = fresh.innerHTML;

      const count = doc.querySelector('[data-cart-count-value]')?.textContent.trim();
      const badge = document.querySelector('[data-cart-count]');
      if (badge && count !== undefined) {
        badge.textContent = count;
        badge.hidden = count === '0';
      }
    }

    // Quick + / - clicks are collected and sent as one update with the final
    // numbers, and only the newest answer redraws the drawer, so the count
    // never jumps back while you are still clicking.
    onQuantityChange(event) {
      const input = event.target.closest('.quantity-selector__input');
      if (!input) return;

      const item = input.closest('.cart-drawer__item');
      const key = item?.querySelector('[data-cart-remove]')?.dataset.key;
      if (!key) return;

      this.pending = this.pending || {};
      this.pending[key] = Math.max(0, Number(input.value) || 0);
      this.requestSeq = (this.requestSeq || 0) + 1;
      clearTimeout(this.quantityTimer);
      this.quantityTimer = setTimeout(() => this.flushQuantities(), 400);
    }

    async flushQuantities() {
      const updates = this.pending;
      this.pending = {};
      if (!updates || !Object.keys(updates).length) return;
      const seq = this.requestSeq;
      // one request at a time, in click order
      const previous = this.inflight || Promise.resolve();
      const request = previous.catch(() => {}).then(() =>
        fetch(window.Shopify.routes.root + 'cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates, sections: 'cart-drawer' }),
        }).then((r) => r.json())
      );
      this.inflight = request;
      const data = await request;
      // a newer click happened meanwhile: its own update will redraw
      if (seq !== this.requestSeq) return;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
    }

    async onRemoveClick(event) {
      const add = event.target.closest('[data-cart-add-variant]');
      if (add) {
        add.disabled = true;
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(add.dataset.cartAddVariant), quantity: 1 }], sections: 'cart-drawer' }),
        });
        const data = await response.json();
        if (response.ok) document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        else add.disabled = false;
        return;
      }

      const button = event.target.closest('[data-cart-remove]');
      if (!button) return;

      await this.updateCart({ id: button.dataset.key, quantity: 0 });
    }

    async updateCart(payload) {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ ...payload, sections: 'cart-drawer' }),
      });
      const data = await response.json();
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
    }
  }

  if (!customElements.get('cart-drawer')) {
    customElements.define('cart-drawer', CartDrawer);
  }

  // Discount code: applied in place through the cart API, no page change.
  async function evoSetDiscounts(codes) {
    const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: codes.join(','), sections: 'cart-drawer' }),
    });
    const data = await response.json();
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
    return data;
  }

  async function evoCurrentCodes() {
    const cart = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json());
    return (cart.discount_codes || []).filter((d) => d.applicable).map((d) => d.code);
  }

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-discount-form]');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('[data-discount-input]');
    const code = input?.value.trim();
    if (!code) return;
    const invalidText = form.dataset.invalidText;
    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;
    try {
      const existing = await evoCurrentCodes();
      const codes = existing.some((c) => c.toLowerCase() === code.toLowerCase()) ? existing : [...existing, code];
      const data = await evoSetDiscounts(codes);
      const result = (data.discount_codes || []).find((d) => d.code.toLowerCase() === code.toLowerCase());
      if (!result || !result.applicable) {
        // keep only the codes that work, and say this one does not
        await evoSetDiscounts((data.discount_codes || []).filter((d) => d.applicable).map((d) => d.code));
        const message = document.querySelector('cart-drawer [data-discount-message]');
        if (message) {
          message.textContent = invalidText;
          message.hidden = false;
        }
        const freshInput = document.querySelector('cart-drawer [data-discount-input]');
        if (freshInput) {
          freshInput.value = code;
          const freshButton = freshInput.form?.querySelector('button[type="submit"]');
          if (freshButton) freshButton.disabled = false;
        }
      }
    } catch (e) {
      if (button) button.disabled = false;
    }
  });

  // "Aktivera" is greyed out until a code is typed
  document.addEventListener('input', (event) => {
    const input = event.target.closest('[data-discount-input]');
    if (!input) return;
    const button = input.form?.querySelector('button[type="submit"]');
    if (button) button.disabled = !input.value.trim();
    const message = input.closest('.cart-drawer__discount')?.querySelector('[data-discount-message]');
    if (message) message.hidden = true;
  });

  document.addEventListener('click', async (event) => {
    const remove = event.target.closest('[data-discount-remove]');
    if (!remove) return;
    remove.disabled = true;
    const code = remove.dataset.discountRemove.toLowerCase();
    const codes = await evoCurrentCodes();
    await evoSetDiscounts(codes.filter((c) => c.toLowerCase() !== code));
  });

  class ProductForm extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.form?.addEventListener('submit', this.onSubmit.bind(this));
    }

    async onSubmit(event) {
      event.preventDefault();
      const submitButton =
        event.submitter || this.form.querySelector('[type="submit"]') || this.querySelector('[type="submit"]');
      if (submitButton) submitButton.disabled = true;
      this.querySelector('.product-form__error')?.remove();

      const formData = new FormData(this.form);
      // The variant picker's choice always wins over the fallback id (else Shopify takes the last "id" = first variant)
      // (form.id would return the <input name="id">, so read the attribute)
      const picked = document.querySelector(`[data-variant-id-input][form="${this.form.getAttribute('id')}"]`);
      if (picked && picked.value) {
        formData.delete('id');
        formData.set('id', picked.value);
      }
      const addons = Array.from(this.form.elements).filter((el) => el.matches('[data-upsell-variant]:checked'));

      try {
        let response;
        if (addons.length) {
          // main product plus the ticked add-on in one request
          response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: [
                { id: Number(formData.get('id')), quantity: Number(formData.get('quantity')) || 1 },
                ...addons.map((el) => ({ id: Number(el.dataset.upsellVariant), quantity: 1 })),
              ],
              sections: 'cart-drawer',
            }),
          });
        } else {
          formData.append('sections', 'cart-drawer');
          response = await fetch(this.form.action, {
            method: 'POST',
            body: formData,
            headers: { Accept: 'application/json' },
          });
        }
        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message);
        }

        addons.forEach((el) => (el.checked = false));
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: data }));
        window.openDialog?.(document.getElementById('cart-drawer'));
      } catch (error) {
        const errorEl = document.createElement('p');
        errorEl.className = 'product-form__error';
        errorEl.textContent = error.message;
        this.form.appendChild(errorEl);
      } finally {
        if (submitButton) submitButton.disabled = false;
      }
    }
  }

  if (!customElements.get('product-form')) {
    customElements.define('product-form', ProductForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class GridDensity extends HTMLElement {
    connectedCallback() {
      this.grid = document.querySelector('[data-density-grid]');
      this.buttons = Array.from(this.querySelectorAll('button'));
      this.buttons.forEach((button) => button.addEventListener('click', () => this.setDensity(button.dataset.densityValue)));

      const stored = localStorage.getItem('theme:grid-density');
      if (stored) this.setDensity(stored);
    }

    setDensity(value) {
      if (!this.grid) return;
      this.grid.dataset.density = value;
      this.buttons.forEach((button) => button.setAttribute('aria-current', String(button.dataset.densityValue === value)));
      localStorage.setItem('theme:grid-density', value);
    }
  }

  if (!customElements.get('grid-density')) {
    customElements.define('grid-density', GridDensity);
  }

  function closeSortDropdown() {
    const toggle = document.querySelector('[data-sort-toggle]');
    const panel = document.querySelector('[data-sort-panel]');
    if (!toggle || !panel) return;
    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
  }

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-sort-toggle]');
    if (toggle) {
      const panel = toggle.closest('[data-sort-dropdown]')?.querySelector('[data-sort-panel]');
      const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
      closeSortDropdown();
      if (!wasOpen && panel) {
        toggle.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
      }
      return;
    }

    if (!event.target.closest('[data-sort-dropdown]')) {
      closeSortDropdown();
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') closeSortDropdown();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-faq-accordion]').forEach((accordion) => {
      accordion.addEventListener('toggle', (event) => {
        if (!event.target.open) return;
        accordion.querySelectorAll('[data-faq-item][open]').forEach((item) => {
          if (item !== event.target) item.open = false;
        });
      }, true);
    });

    document.querySelectorAll('[data-faq-search]').forEach((input) => {
      const wrapper = input.closest('.faq__col-faqs');
      const items = Array.from(wrapper.querySelectorAll('[data-faq-item]'));
      const noResults = wrapper.querySelector('[data-faq-no-results]');

      input.addEventListener('input', () => {
        const query = input.value.trim().toLowerCase();
        let visibleCount = 0;
        items.forEach((item) => {
          const visible = query === '' || item.dataset.faqSearchtext.includes(query);
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });
        if (noResults) noResults.hidden = visibleCount > 0;
      });
    });

  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-product-filter-grid]').forEach((grid) => {
      const wrapper = grid.closest('.featured-grid__inner');
      if (!wrapper) return;
      const categoryButtons = wrapper.querySelectorAll('[data-filter-category]');
      const searchInput = wrapper.querySelector('[data-product-filter-search]');
      const items = Array.from(grid.querySelectorAll('[data-filter-item]'));
      const emptyState = wrapper.querySelector('[data-product-filter-empty]');
      let activeCategory = '';

      const applyFilters = () => {
        const query = (searchInput?.value || '').trim().toLowerCase();
        let visibleCount = 0;

        items.forEach((item) => {
          const card = item.querySelector('.product-card');
          const matchesCategory = activeCategory === '' || card?.dataset.type === activeCategory;
          const matchesSearch = query === '' || item.dataset.filterSearchtext.includes(query);
          const visible = matchesCategory && matchesSearch;
          item.hidden = !visible;
          if (visible) visibleCount += 1;
        });

        if (emptyState) emptyState.hidden = visibleCount > 0;
      };

      categoryButtons.forEach((button) => {
        button.addEventListener('click', () => {
          activeCategory = button.dataset.filterCategory;
          categoryButtons.forEach((btn) => btn.classList.toggle('is-active', btn === button));
          applyFilters();
        });
      });

      searchInput?.addEventListener('input', applyFilters);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (function () {
    function openDialog(dialog) {
      if (!dialog) return;
      if (!dialog.open) dialog.showModal();
      // force a layout so the slide-in transition runs, then open;
      // always add the class (the drawer is off-screen without it)
      void dialog.offsetWidth;
      dialog.classList.add('is-open');
    }

    function closeDialog(dialog) {
      if (!dialog || !dialog.open) return;
      const duration = Math.max(0, ...getComputedStyle(dialog).transitionDuration.split(',').map((t) => parseFloat(t) || 0));
      dialog.classList.remove('is-open');
      if (duration === 0) {
        dialog.close();
        return;
      }
      let finished = false;
      const finish = () => {
        if (finished) return;
        finished = true;
        dialog.removeEventListener('transitionend', finish);
        dialog.close();
      };
      dialog.addEventListener('transitionend', finish);
      setTimeout(finish, duration * 1000 + 50);
    }

    // closed with Esc: reset so the next open slides in again
    document.addEventListener('close', (event) => event.target.classList?.remove('is-open'), true);

    window.openDialog = openDialog;
    window.closeDialog = closeDialog;

    const menuToggle = document.querySelector('[data-mobile-menu-toggle]');
    const menuPanel = document.querySelector('[data-mobile-menu-panel]');
    if (menuToggle && menuPanel) {
      menuToggle.addEventListener('click', () => {
        const isOpen = menuToggle.getAttribute('aria-expanded') === 'true';
        menuToggle.setAttribute('aria-expanded', String(!isOpen));
        menuPanel.hidden = isOpen;
      });
    }

    const desktopMql = window.matchMedia('(min-width: 64rem)');
    desktopMql.addEventListener('change', (event) => {
      if (!event.matches || !menuToggle || !menuPanel) return;
      menuToggle.setAttribute('aria-expanded', 'false');
      menuPanel.hidden = true;
    });

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-dialog-open]');
      if (opener) {
        event.preventDefault();
        const dialogId = opener.dataset.dialogOpen;
        openDialog(document.getElementById(dialogId));
        document.dispatchEvent(new CustomEvent('dialog:open', { detail: { id: dialogId } }));
        return;
      }

      const closer = event.target.closest('[data-dialog-close]');
      if (closer) {
        closeDialog(closer.closest('dialog'));
        return;
      }

      const dialog = event.target.closest('dialog');
      if (dialog && event.target === dialog) {
        closeDialog(dialog);
      }

      const dropdownToggle = event.target.closest('[data-nav-dropdown-toggle]');
      if (dropdownToggle) {
        const wasOpen = dropdownToggle.getAttribute('aria-expanded') === 'true';
        closeAllNavDropdowns();
        if (!wasOpen) {
          dropdownToggle.setAttribute('aria-expanded', 'true');
          dropdownToggle.closest('[data-nav-dropdown]')?.querySelector('[data-nav-dropdown-panel]')?.removeAttribute('hidden');
        }
        return;
      }

      if (!event.target.closest('[data-nav-dropdown]')) {
        closeAllNavDropdowns();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeAllNavDropdowns();
    });

    function closeAllNavDropdowns() {
      document.querySelectorAll('[data-nav-dropdown-toggle][aria-expanded="true"]').forEach((toggle) => {
        toggle.setAttribute('aria-expanded', 'false');
        toggle.closest('[data-nav-dropdown]')?.querySelector('[data-nav-dropdown-panel]')?.setAttribute('hidden', '');
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-info"]) return;
  try {
    
  window.evoInitProductInfo = () => {
    // Tabs section may have been swapped in (linked options)
    if (window.evoInitTabs) window.evoInitTabs();

    // Variant picker block present: it supplies the variant id, drop the fallback
    document.querySelectorAll('form[id^="product-add-form-"]').forEach((form) => {
      const picker = document.querySelector(`[data-variant-id-input][form="${form.getAttribute('id')}"]`);
      const fallback = form.querySelector('[data-fallback-variant-id]');
      if (picker && fallback) fallback.remove();
    });

    // On a paket page, hide add-ons that are already part of the paket
    const bundle = document.querySelector('[data-bundle-contents]');
    if (bundle) {
      const ids = bundle.dataset.bundleContents;
      document.querySelectorAll('[data-addons]').forEach((box) => {
        box.querySelectorAll('[data-addon-product]').forEach((item) => {
          if (ids.includes(`,${item.dataset.addonProduct},`)) {
            item.hidden = true;
            const input = item.querySelector('input');
            if (input) input.checked = false;
          }
        });
        box.hidden = !box.querySelector('[data-addon-product]:not([hidden])');
      });
    }

    // "Order within X to have it shipped today" from a real cutoff (Stockholm time, weekdays)
    const note = document.querySelector('[data-ship-cutoff]');
    if (note) {
      const cutoff = Number(note.dataset.shipCutoff) || 14;
      const zone = 'Europe/Stockholm';
      const now = new Date();
      const parts = Object.fromEntries(
        new Intl.DateTimeFormat('en-GB', { timeZone: zone, weekday: 'short', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
          .formatToParts(now)
          .map((p) => [p.type, p.value])
      );
      const days = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
      const today = days.indexOf(parts.weekday);
      const minutesLeft = cutoff * 60 - (Number(parts.hour) * 60 + Number(parts.minute));
      const text = note.querySelector('[data-ship-text]');
      if (today < 5 && minutesLeft > 0) {
        const h = Math.floor(minutesLeft / 60);
        const m = minutesLeft % 60;
        const hu = note.dataset.hours || 'h';
        const mu = note.dataset.minutes || 'min';
        text.innerHTML = note.dataset.today.replace('[time]', `<strong>${h > 0 ? `${h} ${hu} ` : ''}${m} ${mu}</strong>`);
      } else {
        let add = 1;
        while ((today + add) % 7 >= 5) add += 1;
        if (add === 1) {
          text.innerHTML = note.dataset.tomorrow;
        } else {
          const lang = document.documentElement.lang || 'sv';
          const day = new Intl.DateTimeFormat(lang, { timeZone: zone, weekday: 'long' }).format(new Date(now.getTime() + add * 86400000));
          text.innerHTML = note.dataset.next.replace('[day]', `<strong>${day}</strong>`);
        }
      }
      note.hidden = false;
    }

    // Mobile: show a buy bar at the bottom once the main button has scrolled out of view
    const bar = document.querySelector('[data-sticky-bar]');
    const mainButton = document.querySelector('.product-page__add-to-cart');
    if (bar && mainButton && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(mainButton);
    }
  };
  window.evoInitProductInfo();

  // Linked options: switch to the other product in place (gallery, info and tabs)
  class LinkedOptions extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
    }

    async onClick(event) {
      const card = event.target.closest('[data-url]');
      if (!card || card.getAttribute('aria-pressed') === 'true') return;
      this.querySelectorAll('[data-url]').forEach((el) => el.setAttribute('aria-pressed', String(el === card)));
      const url = card.dataset.url;
      if (!this.dataset.sections || this.dataset.sections.startsWith(',')) {
        window.location.href = url;
        return;
      }
      try {
        const ids = this.dataset.sections;
        const response = await fetch(`${url}${url.includes('?') ? '&' : '?'}sections=${ids}`);
        if (!response.ok) throw new Error(response.status);
        const sections = await response.json();
        Object.entries(sections).forEach(([id, html]) => {
          const current = document.getElementById(`shopify-section-${id}`);
          if (current && html) current.outerHTML = html;
        });
        window.history.replaceState({}, '', url);
        window.evoInitProductInfo();
      } catch (error) {
        window.location.href = url;
      }
    }
  }

  if (!customElements.get('linked-options')) {
    customElements.define('linked-options', LinkedOptions);
  }

  document.addEventListener('variant:change', (event) => {
    const variant = event.detail;
    if (!variant) return;

    const priceBox = document.querySelector('[data-product-price]');
    if (priceBox) {
      const current = priceBox.querySelector('.price__current');
      const compareAt = priceBox.querySelector('.price__compare-at');
      if (current) current.textContent = window.themeStrings.formatMoney(variant.price);
      if (variant.compare_at_price > variant.price) {
        if (compareAt) {
          compareAt.textContent = window.themeStrings.formatMoney(variant.compare_at_price);
          compareAt.hidden = false;
        }
      } else if (compareAt) {
        compareAt.hidden = true;
      }
      const badge = document.querySelector('[data-sale-badge]');
      if (badge) {
        const off = variant.compare_at_price > variant.price
          ? Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price)
          : 0;
        badge.hidden = off <= 0;
        if (off > 0) badge.innerHTML = badge.dataset.template.replace('[percent]', off);
      }
      const savings = priceBox.querySelector('.product-page__savings');
      if (savings) {
        const saved = variant.compare_at_price - variant.price;
        savings.hidden = !(saved > 0);
        if (saved > 0) savings.innerHTML = savings.dataset.template.replace('[amount]', window.themeStrings.formatMoney(saved));
      }
    }

    const totalLabel = document.querySelector('[data-product-total-label]');
    const qtyInput = document.querySelector('.quantity-selector__input');
    if (totalLabel && qtyInput) {
      totalLabel.innerHTML = totalLabel.innerHTML.replace(/<strong>.*<\/strong>/, `<strong>${window.themeStrings.formatMoney(variant.price * Number(qtyInput.value))}</strong>`);
    }

    const stickyPrice = document.querySelector('.product-sticky-bar__price');
    if (stickyPrice) stickyPrice.textContent = window.themeStrings.formatMoney(variant.price);
    const stickyButton = document.querySelector('.product-sticky-bar__button');
    if (stickyButton) stickyButton.disabled = !variant.available;

    const addToCartButton = document.querySelector('.product-page__add-to-cart');
    const addToCartLabel = document.querySelector('[data-add-to-cart-label]');
    if (addToCartButton) addToCartButton.disabled = !variant.available;
    if (addToCartLabel) {
      addToCartLabel.textContent = variant.available ? addToCartLabel.dataset.inStockLabel : addToCartLabel.dataset.soldOutLabel;
    }
  });

  document.addEventListener('change', (event) => {
    const input = event.target.closest('.quantity-selector__input');
    if (!input) return;

    const totalLabel = document.querySelector('[data-product-total-label]');
    const priceEl = document.querySelector('[data-product-price] .price__current');
    if (totalLabel && priceEl) {
      const priceCents = Math.round(parseFloat(priceEl.textContent.replace(/[^0-9.,]/g, '').replace(',', '.')) * 100);
      totalLabel.innerHTML = totalLabel.innerHTML.replace(/<strong>.*<\/strong>/, `<strong>${window.themeStrings.formatMoney(priceCents * Number(input.value))}</strong>`);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-tabs"]) return;
  try {
    
  // Tabs marked [table] in the description: each list line "Label: value" becomes a table row
  const evoListsToTables = (root) => {
    root.querySelectorAll('[data-tab-table]:not([data-table-ready])').forEach((panel) => {
      panel.dataset.tableReady = 'true';
      panel.querySelectorAll(':scope > ul, :scope > ol').forEach((list) => {
        const table = document.createElement('table');
        table.className = 'product-page__spec-table';
        const body = table.createTBody();
        [...list.children].forEach((li) => {
          if (li.tagName !== 'LI') return;
          const nested = [...li.children].filter((el) => el.tagName === 'UL' || el.tagName === 'OL');
          nested.forEach((el) => el.remove());
          const html = li.innerHTML.trim();
          const text = li.textContent;
          const colon = text.indexOf(':');
          const row = body.insertRow();
          const th = document.createElement('th');
          th.scope = 'row';
          const td = row.insertCell();
          if (colon > 0 && colon < 60) {
            // label = text before the first colon, value = the rest (keeps links/bold)
            th.textContent = text.slice(0, colon).trim();
            const tmp = document.createElement('div');
            tmp.innerHTML = html;
            let remaining = colon + 1;
            const walker = document.createTreeWalker(tmp, NodeFilter.SHOW_TEXT);
            let node;
            while ((node = walker.nextNode())) {
              const len = node.textContent.length;
              if (remaining >= len) { remaining -= len; node.textContent = ''; }
              else { node.textContent = node.textContent.slice(remaining); remaining = 0; break; }
            }
            tmp.querySelectorAll('strong, b, em, span').forEach((el) => { if (!el.textContent.trim()) el.remove(); });
            td.innerHTML = tmp.innerHTML.trim();
          } else if (nested.length) {
            th.innerHTML = html;
          } else {
            th.colSpan = 2;
            th.innerHTML = html;
            td.remove();
          }
          row.insertBefore(th, row.firstChild);
          nested.forEach((el) => td.appendChild(el));
        });
        list.replaceWith(table);
      });
    });
  };

  // Builds the tab buttons from the tab blocks (each panel carries its label)
  window.evoInitTabs = () => {
    evoListsToTables(document);
    document.querySelectorAll('[data-product-tabs]').forEach((tabs) => {
      const list = tabs.querySelector('[data-tab-list]');
      const panels = [...tabs.querySelectorAll('[data-tab-panel]')];
      if (!list || list.dataset.ready === 'true') return;
      list.innerHTML = '';
      panels.forEach((panel, index) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'product-page__tab' + (index === 0 ? ' is-active' : '');
        button.setAttribute('role', 'tab');
        button.setAttribute('aria-selected', String(index === 0));
        button.dataset.tabTarget = panel.id;
        button.textContent = panel.dataset.tabLabel;
        list.appendChild(button);
        panel.hidden = index !== 0;
      });
      list.dataset.ready = 'true';
      tabs.hidden = panels.length === 0;
    });
  };
  window.evoInitTabs();
  document.addEventListener('shopify:section:load', window.evoInitTabs);
  document.addEventListener('shopify:block:select', (event) => {
    const panel = event.target.closest('[data-tab-panel]');
    if (!panel) return;
    const button = document.querySelector(`[data-tab-target="${panel.id}"]`);
    if (button) button.click();
  });

  document.addEventListener('click', (event) => {
    const tabButton = event.target.closest('[data-tab-target]');
    if (!tabButton) return;
    const tabs = tabButton.closest('[data-product-tabs]');
    if (!tabs) return;

    tabs.querySelectorAll('.product-page__tab').forEach((tab) => {
      tab.classList.toggle('is-active', tab === tabButton);
      tab.setAttribute('aria-selected', String(tab === tabButton));
    });
    tabs.querySelectorAll('[data-tab-panel]').forEach((panel) => {
      panel.hidden = panel.id !== tabButton.dataset.tabTarget;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-quiz]').forEach((root) => {
      const intro = root.querySelector('[data-quiz-intro]');
      const progress = root.querySelector('[data-quiz-progress]');
      const panels = Array.from(root.querySelectorAll('[data-quiz-panel]'));
      const dots = Array.from(root.querySelectorAll('[data-quiz-dot]'));
      const results = root.querySelector('[data-quiz-results]');
      const resultCards = Array.from(root.querySelectorAll('[data-quiz-result-card]'));
      const totalSteps = panels.length;
      let selectedProductId = null;

      const showStep = (step) => {
        panels.forEach((panel) => {
          panel.hidden = Number(panel.dataset.quizPanel) !== step;
        });
        dots.forEach((dot) => {
          dot.classList.toggle('quiz__dot--active', Number(dot.dataset.quizDot) === step);
        });
      };

      const showResults = () => {
        panels.forEach((panel) => (panel.hidden = true));
        if (progress) progress.hidden = true;
        if (intro) intro.hidden = true;
        resultCards.forEach((card) => {
          card.hidden = card.dataset.productId !== selectedProductId;
        });
        results.hidden = false;
      };

      const reset = () => {
        selectedProductId = null;
        results.hidden = true;
        if (intro) intro.hidden = false;
        if (progress) progress.hidden = false;
        showStep(1);
      };

      root.addEventListener('click', (event) => {
        const option = event.target.closest('[data-quiz-option]');
        if (option) {
          const step = Number(option.dataset.step);
          if (option.dataset.productId) selectedProductId = option.dataset.productId;

          if (step < totalSteps) {
            showStep(step + 1);
          } else {
            showResults();
          }
          return;
        }

        const copyButton = event.target.closest('[data-quiz-copy]');
        if (copyButton) {
          navigator.clipboard.writeText(copyButton.dataset.code);
          const label = copyButton.querySelector('[data-copy-label]');
          if (label) {
            label.textContent = label.dataset.copiedLabel;
            setTimeout(() => {
              label.textContent = label.dataset.copyLabelDefault;
            }, 2000);
          }
          return;
        }

        if (event.target.closest('[data-quiz-retake]')) {
          reset();
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["spin-wheel-popup"]) return;
  try {
    
  (function () {
    const SPIN_STORAGE_KEY = 'theme:spin-wheel-claimed';

    const trigger = document.querySelector('.spin-wheel-trigger');
    if (trigger && !localStorage.getItem(SPIN_STORAGE_KEY)) {
      const delay = Number(trigger.dataset.delay) || 8000;
      setTimeout(() => trigger.classList.add('spin-wheel-trigger--visible'), delay);
    }

    const disc = document.querySelector('[data-spin-wheel-disc]');
    const button = document.querySelector('[data-spin-wheel-button]');
    if (!disc || !button) return;

    const prizes = JSON.parse(document.querySelector('[data-spin-wheel-prizes]')?.textContent || '[]');
    const segmentAngle = 360 / prizes.length;

    prizes.forEach((prize, index) => {
      const label = disc.querySelector(`[data-index="${index}"]`);
      if (label) label.style.transform = `rotate(${segmentAngle * index + segmentAngle / 2}deg)`;
    });

    const colors = ['#206189', '#3e7aa4', '#f59e0b', '#ea580c', '#1e7b34', '#7e5308'];
    const stops = prizes
      .map((_, index) => {
        const from = segmentAngle * index;
        const to = from + segmentAngle;
        return `${colors[index % colors.length]} ${from}deg ${to}deg`;
      })
      .join(', ');
    disc.style.background = `conic-gradient(${stops})`;

    let rotation = 0;
    let hasSpun = false;

    button.addEventListener('click', () => {
      if (hasSpun) return;
      hasSpun = true;

      const index = Math.floor(Math.random() * prizes.length);
      const targetCenter = segmentAngle * index + segmentAngle / 2;
      rotation += 360 * 5 + (360 - targetCenter);
      disc.style.transform = `rotate(${rotation}deg)`;

      disc.addEventListener(
        'transitionend',
        () => {
          const prize = prizes[index];
          const result = document.querySelector('[data-spin-wheel-result]');
          const intro = document.querySelector('[data-spin-wheel-intro]');
          const wheel = document.querySelector('.spin-wheel');

          document.querySelector('[data-result-prize]').textContent = prize.label;
          document.querySelector('[data-result-link]').href = `${window.Shopify.routes.root}discount/${encodeURIComponent(prize.code)}?redirect=/`;

          intro.hidden = true;
          wheel.hidden = true;
          result.hidden = false;

          localStorage.setItem(SPIN_STORAGE_KEY, 'true');
        },
        { once: true }
      );
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsFilter extends HTMLElement {
    connectedCallback() {
      this.grid = this.parentElement.querySelector('.testimonials__grid');
      this.noResults = this.parentElement.querySelector('[data-no-results]');
      this.activeRating = 'all';

      this.addEventListener('click', this.onFilterClick.bind(this));
      this.querySelector('[data-sort-select]')?.addEventListener('change', this.onSortChange.bind(this));
    }

    onFilterClick(event) {
      const button = event.target.closest('[data-rating-filter]');
      if (!button) return;

      this.querySelectorAll('[data-rating-filter]').forEach((el) => el.setAttribute('aria-pressed', 'false'));
      button.setAttribute('aria-pressed', 'true');
      this.activeRating = button.dataset.ratingFilter;
      this.applyFilter();
    }

    onSortChange(event) {
      const cards = Array.from(this.grid.children);
      const sort = event.target.value;

      cards.sort((a, b) => {
        if (sort === 'highest') return Number(b.dataset.rating) - Number(a.dataset.rating);
        if (sort === 'lowest') return Number(a.dataset.rating) - Number(b.dataset.rating);
        return Number(a.style.order) - Number(b.style.order);
      });

      cards.forEach((card, index) => (card.style.order = index));
    }

    applyFilter() {
      let visibleCount = 0;
      Array.from(this.grid.children).forEach((card) => {
        const matches = this.activeRating === 'all' || card.dataset.rating === this.activeRating;
        card.hidden = !matches;
        if (matches) visibleCount += 1;
      });
      this.noResults.hidden = visibleCount > 0;
    }
  }

  if (!customElements.get('testimonials-filter')) {
    customElements.define('testimonials-filter', TestimonialsFilter);
  }

  } catch(e) { console.error(e); }
})();
})();
